import { Page } from '@/components';

import { CryptoIcon, Heading } from '@blockanalitica/ui';
import HoldersKpiWithChart from './HoldersKpiWithChart';
import HoldersEventsTable from './HoldersEventsTable';
import { tokensMapping } from '@/utils/tokens';

export default function SparkTokenHolderPage() {
  return (
    <Page
      title={
        <>
          <CryptoIcon
            name={'SPK'}
            address={tokensMapping('SPK').address}
            size="3"
          />
          <Heading size="1">Spark Token Holders</Heading>
        </>
      }>
      <HoldersKpiWithChart />
      <HoldersEventsTable />
    </Page>
  );
}
